import React, { Suspense } from 'react';
import { RouterProvider } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';
import { Security } from '@core/Okta';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment-timezone';

import { LoadingFullScreen } from '@components/atoms/Loading';
import { PublicRoutes, router } from '@core/routes/routeConfig';
import { ErrorFallback } from '@components/atoms/ErrorFallback';
import oktaAuth from '@core/Okta/oktaAuth';

export default function App() {
  return (
    <Security oktaAuth={oktaAuth} publicRoutes={PublicRoutes}>
      <LocalizationProvider
        dateAdapter={AdapterMoment}
        dateLibInstance={moment}
      >
        <ErrorBoundary FallbackComponent={ErrorFallback}>
          <Suspense fallback={<LoadingFullScreen loading />}>
            <RouterProvider router={router} />
          </Suspense>
        </ErrorBoundary>
      </LocalizationProvider>
    </Security>
  );
}
